import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import LoggerUtils from "../../utils/logger/LoggerUtils";

// Utility functions for token management
export const setTokens = ({ access_token, refresh_token }) => {
  if (access_token) localStorage.setItem("accessToken", access_token);
  if (refresh_token) localStorage.setItem("refreshToken", refresh_token);
};

export const getAccessToken = () => localStorage.getItem("accessToken");
export const getRefreshToken = () => localStorage.getItem("refreshToken");
export const clearTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

export const fetchAccessToken = createAsyncThunk(
  "user/fetchAccessToken",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/token`,
        new URLSearchParams({
          client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
          grant_type: "password",
          username,
          password,
        }),
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // Store both tokens
      const { access_token, refresh_token } = response.data;
      setTokens({ access_token, refresh_token });
      return access_token;
    } catch (error) {
      LoggerUtils.logError("fetching access token", error);
      return rejectWithValue(error.message);
    }
  }
);

export const refreshAccessToken = createAsyncThunk(
  "user/refreshAccessToken",
  async (refreshToken, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/refresh`,
        { refresh_token: refreshToken },
        { headers: { "Content-Type": "application/json" } }
      );
      const { access_token, refresh_token } = response.data;
      setTokens({ access_token, refresh_token });
      return access_token;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Special value to indicate logout is needed
        return rejectWithValue({ logout: true, message: error.message });
      }
      LoggerUtils.logError("refreshing access token", error);
      return rejectWithValue({ logout: false, message: error.message });
    }
  }
);

export const fetchUser = createAsyncThunk(
  "user/fetchUser",
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/me`,
        {},
        {
          headers: {
            accept: "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      const {
        exp,
        iat,
        azp,
        realm_access,
        name,
        preferred_username,
        given_name,
        family_name,
        email,
      } = response.data;
      const roles = realm_access.roles;
      return {
        exp,
        iat,
        azp,
        roles,
        name,
        preferred_username,
        given_name,
        family_name,
        email,
      };
    } catch (error) {
      LoggerUtils.logError("fetching user", error);
      return rejectWithValue(error.message);
    }
  }
);
